export default {
  init() {
    // JavaScript to be fired on the Contact page
    // VIDEOS
    $.ajax({
      url: 'http://vets.esw.me/cities.json',
      type: 'GET',
      dataType: 'json',
      success: function (data) {
        for (var i = 0, len = data.length; i < len; i++) {
          var id = data[i]['id'];
          var city = data[i]['city'];
          var zip = data[i]['zip'];
          var phone = data[i]['phone'];
          var address = data[i]['address'];
          var summary =
            '<li><a class="city" id="' +
            id +
            '" city="' +
            city +
            '" address="' +
            address +
            '" phone="' +
            phone +
            '" zip="' +
            zip +
            '">' +
            city +
            '</a></li>';
          $('#cities').append(summary);

          $('.city').click(function (e) {
            e.preventDefault();

            // ' + $(this).attr('id') + '

            var url =
              '<h1>' +
              $(this).attr('city') +
              '</h1><h3>' +
              $(this).attr('zip') +
              '</h3><p>' +
              $(this).attr('address') +
              '</p><p>' +
              $(this).attr('phone') +
              '</p>';

            $('#cityInfo').html(url);
          });
        }
      },
      // complete: function (data) {
      /*
        $('.videoSlider').slick({
        rtl:false, // If RTL Make it true & .slick-slide{float:right;}
        autoplay:false,
        infinite: true,
        speed:800, // Transition Speed
        slidesToShow:4, // Number Of Carousel
        slidesToScroll:4, // Slide To Move
        pauseOnHover:false,
        appendArrows:$('.slider-wrap .arrows'), // Class For Arrows Buttons
        prevArrow:'<span class='Slick-Prev'><i class='ion-ios-arrow-thin-left'></i></span>',
        nextArrow:'<span class='Slick-Next'><i class='ion-ios-arrow-thin-right'></i></span>',
        easing:'linear'
        });
      */
      // },
    });

    var apikey = '4debbc67be59fdd456dd6b46b90619f5';
    var url = 'http://api.openweathermap.org/data/2.5/weather?zip=';
    // var title = $('#weather');

    //get the user entered city and state
    function getSearch() {
      $('#city, #temp').empty();
      url = 'http://api.openweathermap.org/data/2.5/weather?zip=';
      var zipcode = $('#search').val();
      url += zipcode + '&APPID=' + apikey + '&units=';

      $.getJSON(url + 'imperial', getWeather, 'jsonp');
    }

    function getWeather(data) {
      var condition = data.weather[0].main;
      $('#city').html(data.name + ', ' + data.sys.country);
      $('#temp').html(Math.round(data.main.temp) + '&deg;');
      $('#desc').html(condition);
    }

    $(document).ready(function () {
      $('#button').click(function () {
        getSearch();
        $('#search').val('');
      });
    });
  },
  finalize() {
    // JavaScript to be fired on the Contact page, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/contact.js